export const ugovor_o_posredovanju = {
    templateId: 200,
    category: 16,
    templateTitle: "Ugovor o posredovanju",
    templateDescription: `<p>Ugovorom o posredovanju posrednik se obvezuje dovesti u vezu s nalogodavceom osobu koja bi pregovarala s nalogodavcem o sklapanju ugovora, a nalogodavac se obvezuje isplatiti posredniku određenu proviziju ukoliko ugovor bude sklopljen.</p>`,
    description: `
    <p>Ugovorom o posredovanju obvezuje se posrednik dovesti u vezu s nalogodavcem osobu koja bi s njim pregovarala o sklapanju ugovora, a nalogodavac se obvezuje isplatiti mu određenu proviziju, ako ugovor bude sklopljen.</p>
    <p>Uloga posrednika sastoji se u dovođenju svojeg nalogodavca (komitenta) u kontakt s potencijalnim partnerima za sklapanje određenih ugovora.     </p>
    <p>Posredovanje se smatra. zastupanjem u širem smislu odnosno, indirektnim odnosno neizravnim zastupanjem.</p>
    <p>Posrednik ne sklapa ugovor s trećom osobom i po tome se bitno razlikuje od komisionara i zastupnika.    </p>
    <p>Nalogodavac može opozvati nalog za posredovanje kad god hoće, ako se toga nije odrekao i ako to nije protivno savjesnosti.</p>
    <p>Nalogodavac nije dužan pristupiti pregovorima za sklapanje ugovora s osobom koju je posrednik našao, ni sklopiti s njom ugovor pod uvjetima koje je priopćio posredniku, ali će odgovarati za štetu ako je postupio protivno savjesnosti.</p>
    <p>Posrednik je dužan posredovati u pregovorima i nastojati da dođe do sklapanja ugovora, ako se na to posebno obvezao.</p>
    <p>Posrednik ima pravo na proviziju i kad nije ugovorena.</p>
    <p>Ako visina provizije nije određena ni tarifom ili kojim drugim općim aktom, ni ugovorom, a ni običajem, odredit će je sud prema posrednikovu trudu i učinjenoj usluzi.</p>
    <p>Posrednik nema pravo na naknadu troškova učinjenih u izvršenju naloga, osim kad je to ugovoreno, no u tom slučaju ima pravo na tu naknadu troškova i u slučaju kad ugovor nije sklopljen.    </p>
    <p>Posrednik može posredovati za obje ugovorne strane, no isto mu može biti i ugovorom zabranjeno. </p>
    <p>Ukoliko je takvo posredovanje dopušteno, u nepostojanju drugačijeg dogovora, posrednik koji je dobio nalog za posredovanje od obiju strana može zahtijevati od svake strane samo polovicu provizije i naknadu polovice troškova ako je naknada troškova ugovorena.</p>
    <p>Posrednik koji protivno ugovoru ili protivno interesima svog nalogodavca radi za drugu stranu, gubi pravo na proviziju i na naknadu troškova.</p>
    <p>Posredovanje treba razlikovati u odnosu na trgovinsko zastupanje.</p>
    <p>Pod zastupanjem u užem smislu smatra se zastupanje u kojem zastupnik svojim izjavama volje preuzima za račun zastupanog prava i obveze (direktno, izravno zastupanje). </p>
    <p>Smisao ugovora o trgovinskom zastupanju je kontinuirana briga da treće osobe sklapaju ugovore s njegovim nalogodavcem. </p>
    <p>Zastupnik (trgovinski zastupnik) se obvezuje pregovarati s trećim osobama o sklapanju ugovora u ime i za račun nalogodavca te ako je tako ugovoreno, i sklapati ugovore s trećim osobama u ime i za račun nalogodavca.</p>
 
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
      signature: "Za Nalogodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: ' (u daljnjem tekstu: Nalogodavac)',
      delimiter: "i"
    },
    {
      signature: "Za  Posrednika:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: ' (u daljnjem tekstu: Primatelj)',

    }
  ],


    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O POSREDOVANJU',
    noArticleNumbers: false,
  articles: [

    {
      title: 'PREDMET UGOVORA',
      mandatory: true,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ugovorne strane suglasno utvrđuju da se temeljem ovog ugovora o posredovanju (u daljnjem tekstu: Ugovor), posrednik obvezuje s pozornošću urednog i savjesnog gospodarstvenika poduzimati sve potrebne radnje u svrhu pronalaženja i dovođenja u vezu s Nalogodavcem treće osobe. a koja bi s Nalogodavcem pregovarala o _________________ .',
              value: '',
          }],
  },  
  
  {
    title: 'PODRUČJE POSREDOVANJA',
    mandatory: true,
    exampleContent: true,
    statements: [
        {
            type: 'text',
            required: false,
            mandatory: true,
            editable: true,
            content: 'Posrednik će obavljati posredovanje na području ____________________.',
            value: '',
        }],
}, 
{
  title: 'OBVEZE POSREDNIKA',
  mandatory: true,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Posrednik se obvezuje: \r\n- u pronalaženju potencijalnih kupaca/klijenata Nalogodavcu voditi posebnog računa o njihovom poslovnom bonitetu, \r\n- tijekom izvršenja ovog Ugovora, držati se uputa Nalogodavca. \r\nPosrednik se obavezuje da će u obavljanju povjerenih mu poslova, uvijek štititi interese Nalogodavca, postupajući pritom savjesno i s pažnjom dobrog gospodarstvenika. \r\nPosrednik je dužan obavijestiti Nalogodavca o svim okolnostima značajnim za namjeravani posao koje su mu poznate ili su mu morale biti poznate. ',
          value: '',
      }],
}, 
{
  title: 'POSLOVNA TAJNA',
  mandatory: false,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Sve okolnosti koje sazna tijekom izvršavanja poslova iz ovog Ugovora, a koje mogu biti od utjecaja na tijek Nalogodavčevih poslova, Posrednik je dužan čuvati kao poslovnu tajnu i poslije prestanka ovog Ugovora. \r\nPosrednik odgovara Nalogodavcu za štetu koja bi mu bila prouzrokovana odavanjem poslovne tajne.',
          value: '',
      }],
},
{
  title: 'OBVEZE NALOGODAVCA',
  mandatory: true,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Nalogodavac se obvezuje predati Posredniku specifikaciju robe (količine, sorte, dostupnost) čije posredovanje u prodaji se ugovara ovim Ugovorom.   \r\nObveza Nalogodavca prema ovom ugovoru je da Posredniku prilikom svakog posredovanja po kojemu je sklopljen kupoprodajni ugovor, isplati ugovorenu posredničku proviziju prema odredbama ovog Ugovora, čija obveza plaćanja dospijeva danom naplate od strane krajnjeg kupca.  \r\nNalogodavac nije dužan pristupiti pregovorima za sklapanje ugovora s osobom koju je Posrednik našao, ni sklopiti s njom ugovor pod uvjetima koje je priopćio Posredniku, ali će odgovarati za štetu ako je postupio protivno savjesnosti.          ',
          value: '',
      }],
}, 
{
  title: 'PROVIZIJA',
  mandatory: true,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Posrednička provizija iznosi __% (slovima: ___ posto).  \r\nPosrednička provizija obračunava se na iznos komercijalnog računa obavljene prodaje robe temeljem posredovanja iz ovog Ugovora, pri čemu se u iznos računa ne uračunava trošak prijevoza, carinjenja, porezi i svi ostali troškovi i nameti koji se ne odnose na vrijednost robe iskazanu u fakturi.\r\nPosrednik stječe pravo na proviziju tek nakon naplate potraživanja od Kupaca, temeljem isporuka robe po sklopljenim ugovorima za koje je posredovao.   ',
          value: '',
      }],
},  

{
  title: 'GUBITAK PRAVA NA PROVIZIJU',
  mandatory: false,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Posrednik koji protivno ugovoru ili protivno interesima svog Nalogodavca radi za drugu stranu, gubi pravo na proviziju.          ',
          value: '',
      }],
},  
{
  title: "NAKNADA TROŠKOVA",
  mandatory: false,
  exampleContent: true,
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Posrednik nema pravo na naknadu troškova učinjenih u izvršenju naloga, nego se podrazumijeva da njegova provizija obuhvaća i sve troškove, a ne samo proviziju za obavljeni posao.        ",
        "Posrednik ima pravo na naknadu troškova smještaja i prijevoza ostvarenih u izvršenju posredovanja, uz obvezu da Nalogodavac prethodno odobri svaki takav trošak.\r\nPosrednik ima pravo na tu naknadu i u slučaju da ugovor nije sklopljen. \r\nPosrednik koji protivno ugovoru ili protivno interesima svog Nalogodavca radi za drugu stranu, gubi pravo na naknadu troškova. ",
      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: "POSREDOVANJE ZA OBJE STRANE",
  mandatory: false,
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Posrednik ne može posredovati za drugu stranu s kojom Nalogodavac pregovara oko sklapanja Ugovora.",
        "Ako drugačije nije ugovoreno, Posrednik koji je dobio nalog za posredovanje od obiju strana može zahtijevati od svake strane samo polovicu provizije i naknadu polovice troškova ako je naknada troškova ugovorena.",
      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: 'OPOZIV NALOGA ZA POSREDOVANJE',
  mandatory: false,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Nalogodavac može opozvati nalog za posredovanje iz ovog Ugovora kad hoće, bez ikakve štetne posljedice po njega. \r\nUkoliko Nalogodavac nakon opoziva naloga za posredovanje u kojem je Posrednik poduzimao radnje i ispunjavao obveze potajno sklopi pravni posao s osobom s kojom ga je Posrednik doveo u vezu, Posredniku pripada dvostruki iznos ugovorene posredničke naknade koja bi mu pripala temeljem ovog Ugovora.          ',
          value: '',
      }],
},  
{
  title: 'TRAJANJE I PRESTANAK UGOVORA',
  mandatory: true,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Ovaj Ugovor se sklapa na određeno vrijeme do _____ radi posredovanja u prodaji robe iz ovog Ugovora, a primjenjuje se odmah po potpisu ugovornih strana.\r\nSvaka ugovorna strana može jednostrano otkazati ovaj Ugovor bez navođenja razloga slanjem pisane obavijesti o otkazu drugoj ugovornoj strani uz otkazni rok od 30 dana od dana prijema obavijesti o otkazu.          ',
          value: '',
      }],
},  
{
  title: 'RASKID UGOVORA',
  mandatory: false,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: true,
          mandatory: true,
          editable: true,
          content: 'U slučaju da jedna ugovorna strana krši obveze iz ovog Ugovora, druga ugovorna strana može pisanim putem raskinuti ugovor uz otkazni rok od 15 dana, a koji počinje teći od trenutka dostave obavijesti o raskidu drugoj ugovornoj strani.',
          value: '',
      },
  ],
  value: '',
}, 

    {
  title: 'NADLEŽNOST',
  mandatory: false,
  statements: [
      {
          type: 'choice',
          mandatory: true,
          editable: false,
          choices: [
              {
                  parts: [
                      {
                          type: 'text',
                          content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Nalogodavca.'
                      }
                  ]
              },
              {
                  parts: [
                      {
                          type: 'text',
                          content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Posrednika.'
                      }
                  ]
              },
              {
                  parts: [
                      {
                          type: 'text',
                          content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                      },
                      {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                 ]
              }
          ],
          value: '',
      }
  ]
},
{
  title: 'PRIMJENA UGOVORA',
  mandatory: false,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
          value: '',
      }],
},
{
  title: 'PRIMJERCI UGOVORA',
  mandatory: false,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
          value: '',
      }],
},
{
  mandatory: true,
  static: true,
  type: 2, // date and place
  statements: [
    {
      type: "input",
      mandatory: true,
      parts: [
        {
          type: "text",
          content: "U"
        },
        {
          type: "input",
          value: "",
          placeholder: "Upišite mjesto.",
          required: true,
        },
        {
          type: "text",
          content: ", dana"
        },
        {
          type: "date",
          value: new Date(),
          required: true
        },
        {
          type: "text",
          content: "godine."
        }
      ]
    },
  ]
},
{
  mandatory: true,
  static: true,
  type: 3,  // signatures
  statements: [],
},
],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/200_ugovor_o_posredovanju.ts